module.exports = __webpack_public_path__ + "img/gantanhao.14cf94bd.png";